var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _circle29, _circle30, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFundHoldings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.549,
    cy: 41.5158,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.476,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.956,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.569,
    cy: 98.318,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.8076,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.066 100.347C167.066 137.155 136.962 167.009 99.8076 167.009C62.6536 167.009 32.5493 137.155 32.5493 100.347C32.5493 63.539 62.6536 33.6853 99.8076 33.6853C136.962 33.6853 167.066 63.539 167.066 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.11489,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.1701,
    cy: 192.829,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.45,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.197,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 127.97,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.354,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 173.793,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.068,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 179.76,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 183.579,
    cy: 93.5446,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.455,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 185.966,
    cy: 40.7998,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.3159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.1865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 43.9599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12.9331,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19.8545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.19333,
    cy: 94.4995,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.0478,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 24.8667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.3823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 107.922,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.936,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.975 150.347C168.921 150.347 168.066 149.493 168.066 148.438C168.066 147.384 168.921 146.529 169.975 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01221 117.65C7.0667 117.65 7.92153 116.795 7.92153 115.741C7.92153 114.686 7.0667 113.831 6.01221 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0317 22.4226C75.0862 22.4226 75.9411 21.5678 75.9411 20.5133C75.9411 19.4588 75.0862 18.604 74.0317 18.604",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 15.7399C119.279 15.7399 118.424 16.5948 118.424 17.6493C118.424 18.7038 119.279 19.5586 120.333 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83057 166.934H15.7972M25.8211 155.836V157.388M37.5157 166.934H39.0671M25.8211 176.481V178.271M25.8211 180.658V186.982M21.4058 166.934C24.3892 166.934 25.9405 162.638 25.9405 162.638C25.9405 162.638 26.4178 166.934 30.2365 166.934C28.5181 166.934 26.0598 168.486 25.8211 171.588C25.8211 171.588 25.5432 169.048 24.6278 168.128C23.8635 167.359 21.4058 166.934 21.4058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.209 30.0596L172.242 30.0596M162.099 45.8115L162.218 39.6062M150.524 30.0596L148.972 30.0596M162.099 20.7516L162.099 8.57973M166.634 30.0596C163.65 30.0596 162.099 34.3556 162.099 34.3556C162.099 34.3556 161.622 30.0596 157.803 30.0596C159.521 30.0596 161.98 28.5083 162.218 25.4056C162.218 25.4056 162.496 27.9458 163.412 28.8663C164.176 29.6348 166.634 30.0596 166.634 30.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.3252,
    cy: 75.3208,
    r: 47.3208,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.3254,
    cy: 75.3207,
    r: 38.9172,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7926 95.5852C70.2372 95.5852 65.0166 93.4204 61.0877 89.4975C57.1588 85.5746 55 80.3481 55 74.7926C55 69.2372 57.1648 64.0166 61.0877 60.0877C65.0106 56.1588 70.2372 54 75.7926 54C81.3481 54 86.5687 56.1648 90.4976 60.0877C94.4264 64.0106 96.5852 69.2372 96.5852 74.7926C96.5852 80.3481 94.4205 85.5686 90.4976 89.4975C86.5746 93.4264 81.3481 95.5852 75.7926 95.5852ZM75.7926 54.2392C70.3029 54.2392 65.1422 56.3801 61.2611 60.2611C57.3801 64.1422 55.2392 69.3029 55.2392 74.7926C55.2392 80.2823 57.3801 85.4431 61.2611 89.3241C65.1422 93.2052 70.3029 95.346 75.7926 95.346C81.2823 95.346 86.4431 93.2052 90.3241 89.3241C94.2052 85.4431 96.346 80.2823 96.346 74.7926C96.346 69.3029 94.2052 64.1422 90.3241 60.2611C86.4431 56.3801 81.2823 54.2392 75.7926 54.2392Z",
    fill: "#194590"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7929 90.1134C71.7026 90.1134 67.8574 88.5227 64.9631 85.6284C62.0687 82.7341 60.478 78.8889 60.478 74.7985C60.478 70.7082 62.0687 66.863 64.9631 63.9687C67.8574 61.0743 71.7026 59.4836 75.7929 59.4836C79.8833 59.4836 83.7284 61.0743 86.6228 63.9687C89.5171 66.863 91.1078 70.7082 91.1078 74.7985C91.1078 78.8889 89.5171 82.7341 86.6228 85.6284C83.7284 88.5227 79.8833 90.1134 75.7929 90.1134ZM75.7929 59.7109C71.7624 59.7109 67.977 61.2777 65.1305 64.1301C62.284 66.9766 60.7112 70.762 60.7112 74.7926C60.7112 78.8231 62.278 82.6085 65.1305 85.455C67.977 88.3015 71.7624 89.8742 75.7929 89.8742C79.8235 89.8742 83.6088 88.3075 86.4553 85.455C89.3018 82.6085 90.8746 78.8231 90.8746 74.7926C90.8746 70.762 89.3078 66.9766 86.4553 64.1301C83.6088 61.2836 79.8235 59.7109 75.7929 59.7109Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7917 80.7311C72.5146 80.7311 69.8535 78.07 69.8535 74.7929C69.8535 71.5159 72.5146 68.8547 75.7917 68.8547C79.0688 68.8547 81.7299 71.5159 81.7299 74.7929C81.7299 78.07 79.0688 80.7311 75.7917 80.7311ZM75.7917 69.0939C72.6522 69.0939 70.0927 71.6534 70.0927 74.7929C70.0927 77.9324 72.6522 80.4919 75.7917 80.4919C78.9312 80.4919 81.4907 77.9324 81.4907 74.7929C81.4907 71.6534 78.9312 69.0939 75.7917 69.0939Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M84.9784 78.5184C90.3222 78.5184 94.6542 74.1864 94.6542 68.8427C94.6542 63.499 90.3222 59.167 84.9784 59.167C79.6347 59.167 75.3027 63.499 75.3027 68.8427C75.3027 74.1864 79.6347 78.5184 84.9784 78.5184Z",
    fill: "#194590"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7926 95.5852C70.2372 95.5852 65.0166 93.4204 61.0877 89.4975C57.1588 85.5746 55 80.3481 55 74.7926C55 69.2372 57.1648 64.0166 61.0877 60.0877C65.0106 56.1588 70.2372 54 75.7926 54C81.3481 54 86.5687 56.1648 90.4976 60.0877C94.4264 64.0106 96.5852 69.2372 96.5852 74.7926C96.5852 80.3481 94.4205 85.5686 90.4976 89.4975C86.5746 93.4264 81.3481 95.5852 75.7926 95.5852ZM75.7926 54.2392C70.3029 54.2392 65.1422 56.3801 61.2611 60.2611C57.3801 64.1422 55.2392 69.3029 55.2392 74.7926C55.2392 80.2823 57.3801 85.4431 61.2611 89.3241C65.1422 93.2052 70.3029 95.346 75.7926 95.346C81.2823 95.346 86.4431 93.2052 90.3241 89.3241C94.2052 85.4431 96.346 80.2823 96.346 74.7926C96.346 69.3029 94.2052 64.1422 90.3241 60.2611C86.4431 56.3801 81.2823 54.2392 75.7926 54.2392Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M58.7849 76.0007C57.5411 76.0007 56.3391 76.1682 55.1909 76.4791C55.2866 77.6333 55.472 78.7575 55.7471 79.8519C56.7039 79.5529 57.7265 79.3914 58.7849 79.3914C64.4181 79.3914 68.9869 83.9602 68.9869 89.5934C68.9869 91.1482 68.64 92.6252 68.0121 93.9468C69.0586 94.3714 70.153 94.7183 71.2772 94.9694C71.9889 93.3189 72.3835 91.507 72.3835 89.5993C72.3776 82.0884 66.2899 76.0007 58.7849 76.0007Z",
    fill: "#194590"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9403 60.7218C89.4992 59.173 87.8307 57.8454 85.9769 56.7989C87.1131 57.9591 87.8188 59.5438 87.8188 61.2959C87.8188 64.8421 84.9483 67.7125 81.4022 67.7125C77.856 67.7125 74.9856 64.8421 74.9856 61.2959C74.9856 57.7617 77.8381 54.8973 81.3663 54.8793C79.5962 54.383 77.7245 54.1199 75.7989 54.1199C75.5597 54.1199 75.3205 54.1259 75.0813 54.1318C73.1019 55.884 71.8521 58.4434 71.8521 61.2959C71.8521 66.5763 76.1278 70.852 81.4082 70.852C86.6885 70.852 90.9643 66.5763 90.9643 61.2959C90.9583 61.1046 90.9463 60.9132 90.9403 60.7218Z",
    fill: "#194590"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112.476,
    y: 126.82,
    width: 21.5508,
    height: 49.407,
    rx: 4,
    transform: "rotate(-44.8121 112.476 126.82)",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.038 112.437L116.242 123.642",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.441 104.033L124.646 115.238",
    stroke: "#787E8C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFundHoldings);
export default __webpack_public_path__ + "static/media/no-fund-holdings.07e519bc31ca5337fbc663d53ddbb116.svg";
export { ForwardRef as ReactComponent };